import { render, staticRenderFns } from "./RegisterAttention.vue?vue&type=template&id=2083d385&"
import script from "./RegisterAttention.vue?vue&type=script&lang=js&"
export * from "./RegisterAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports